// extracted by mini-css-extract-plugin
export default {"form":"form__svwJf5","checkbox":"checkbox__XDIOLz"};